import { useCallback } from 'react';
import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useSimulatorStore } from '../../stores/useSimulatorStore';
import { useIsMobile } from '../../hooks/useIsMobile';
import { ChatPanelContent } from './ChatPanelContent';

export function ChatPanel() {
  const isMobile = useIsMobile();
  const open = useSimulatorStore(s => s.chatPanelOpen);
  const close = useCallback(() => useSimulatorStore.getState().setChatPanelOpen(false), []);

  if (isMobile) return null;

  return createPortal(
    <AnimatePresence>
      {open && (
        <div className="fixed inset-0 z-[90] overflow-hidden">
          <motion.div
            className="absolute inset-0"
            style={{ backgroundColor: 'var(--color-backdrop)' }}
            initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            onClick={close}
          />

          <motion.aside
            className="absolute top-0 right-0 h-full w-[440px] max-w-[95vw] shadow-2xl flex flex-col"
            style={{ backgroundColor: 'var(--color-card)', borderLeft: '1px solid var(--color-border)' }}
            initial={{ x: '100%' }} animate={{ x: 0 }} exit={{ x: '100%' }}
            transition={{ type: 'spring', damping: 30, stiffness: 300 }}
          >
            <ChatPanelContent onClose={close} showBack={false} />
          </motion.aside>
        </div>
      )}
    </AnimatePresence>,
    document.body
  );
}
